export default {"src":"/_next/static/media/scroll_color.c1cdf491.svg","height":32,"width":32};